<script lang="ts">
	import Popover from '$lib/components/Popover/Popover.svelte';
	import { page } from '$app/stores';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { _ } from 'svelte-i18n';
	import { atLeastModerator } from '$lib/utils/roles';
	import { openWidgetModal } from '$lib/components/WidgetModal/widgetHelpers';
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;

	const origin = `${$page.url.origin}/${$page.params.hubPrefix}`;
	const content = `${origin}/content`;
	const settings = `${origin}/settings`;

	const contentPerms = $hub.user_context.perms.manage_content;
</script>

<Popover position="bottom-inline-start" closeOnClick={true}>
	<Icon clickable icon="compose" size="24" color={$hub.theme.headerIconColor} slot="target" />
	<ul slot="content">
		<!-- Hiding the compose options until they are implemented

		{#if canPostInAnyCollection($hub.user_context, $collections)}
		<li>
			<a href="/{$page.params.hubPrefix}"
				><Icon icon="link" size="24" color="black" /><span>{$_('common.share.link')}</span></a
			>
		</li>
		<li>
			<a href="/{$page.params.hubPrefix}"
				><Icon icon="upload" size="24" color="black" /><span>{$_('common.upload.file')}</span></a
			>
		</li>
		<li
			on:click|preventDefault={() => {
				isComposerOpen = true;
			}}
		>
			<a rel="external" href="{content}/compose"
				><Icon icon="compose" size="24" color="black" /><span>{$_('common.compose')}</span></a
			>
		</li>
		{/if}
		-->
		{#if contentPerms.posts.published}
			<li>
				<a href="{content}/published"
					><Icon icon="manage" size="24" color="black" /><span>{$_('common.manage.content')}</span
					></a>
			</li>
		{/if}
		{#if contentPerms.posts.scheduled}
			<li>
				<a href="{content}/scheduled"
					><Icon icon="time" size="24" color="black" /><span>{$_('common.scheduled')}</span></a>
			</li>
		{/if}
		{#if contentPerms.posts.drafts}
			<li>
				<a href="{content}/drafts"
					><Icon icon="draft" size="24" color="black" /><span>{$_('common.drafts')}</span></a>
			</li>
		{/if}
		{#if contentPerms.posts.submissions}
			<li>
				<a href="{content}/submissions"
					><Icon icon="submission" size="24" color="black" /><span>{$_('common.submissions')}</span
					></a>
			</li>
		{/if}

		{#if atLeastModerator($hub.user_context)}
			{#if $hub.settings.feature.nextGenUI == true}
				<li>
					<button type="button" on:click={() => openWidgetModal()}>
						<Icon icon="poll" size="24" color="black" /><span>{$_('common.quickpolls')}</span>
					</button>
				</li>
				<li>
					<button type="button" on:click={() => openWidgetModal(true)}>
						<Icon icon="ctas" size="24" color="black" /><span
							>{$_('hub.settings.widgets.new')}</span>
					</button>
				</li>
			{:else}
				<li>
					<a rel="external" href="{settings}/widgets?app=bluesuede"
						><Icon icon="poll" size="24" color="black" /><span>{$_('common.quickpolls')}</span></a>
				</li>
			{/if}
		{/if}
		{#if contentPerms.newsletters}
			<li>
				<a href="{content}/newsletters/overview/summary"
					><Icon icon="email" size="24" color="black" /><span>{$_('common.newsletters')}</span></a>
			</li>
		{/if}
	</ul>
</Popover>

<style>
	li {
		border-block-end: 1px solid var(--grayLighter);
		color: var(--grayDark);
	}

	li:last-child {
		border-block-end: none;
	}

	a,
	button {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		inline-size: 200px;
		padding-block: var(--gutterSmall);
		padding-inline: var(--gutterMedium);
		border: none;
		background-color: white;
		color: var(--grayDark);
		font-size: var(--fontSizeSmall);
		cursor: pointer;
	}

	a:hover,
	button:hover {
		background-color: var(--grayLighter);
		text-decoration: none;
	}

	span {
		margin-block: 0;
		margin-inline: var(--gutterSmall);
	}
</style>
